import { type uCoastWindow } from '@/scripts/setup'
import { ProductCard } from '@/scripts/theme/product-card'
import { qsOptional, qsRequired } from '@/scripts/core/global'
import {
	displayDataFromProductVariant,
	getSectionHTMLForResource,
	variantFromProductOptions,
} from '@/scripts/core/cart-functions'

declare let window: uCoastWindow

export class ProductDetail extends ProductCard {
	static override htmlSelector = 'product-detail'
	sizeEl?: HTMLElement
	galleryEl: HTMLElement

	constructor() {
		super()
		this.sizeEl = qsOptional('[data-product-size]', this)
		this.galleryEl = qsRequired('[data-product-gallery]')
	}
	override updateSelectedVariant() {
		const elements = this?.elements
		if (!elements) throw new Error('cant update variant, no elements found')
		if (!this.variantData)
			throw new Error('cant update variant, no variant data found')
		const options = this.getOptionValues()
		const variant = variantFromProductOptions(options, this.variantData)
		const displayData = displayDataFromProductVariant(variant)
		elements.variantIdInput.value = variant.id.toString()
		elements.dynamicText.priceTextEl.innerHTML =
			displayData.locale_price_without_trailing_zeros
		elements.dynamicText.actionTextEl.innerHTML =
			displayData.inventory_status_text
		if (displayData.complete_size && this.sizeEl) {
			this.sizeEl.innerHTML = displayData.complete_size
			void this.updateGallery(displayData.product_url)
		}
		if (displayData.inventory_status === 'OutOfStock') {
			elements.submitButton.setAttribute('data-oos', 'true')
		} else {
			elements.submitButton.removeAttribute('data-oos')
		}
	}
	async updateGallery(productUrl: string) {
		const mediaGallery = await getSectionHTMLForResource(
			productUrl,
			'dynamic-product-gallery'
		)
		if (!mediaGallery) return
		this.galleryEl.innerHTML = mediaGallery
		window.Ucoast.mediaManager.reload()
	}
}
